import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import FieldSchemesAppQuery from './__generated__/FieldSchemesAppQuery.graphql';

export const globalAdminFieldSchemesEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-jira-admin-pages-field-schemes" */ './FieldSchemesApp.tsx'
			),
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		queries: {
			pageQueryRef: {
				parameters: FieldSchemesAppQuery,
				variables: {
					cloudId: tenantContext.cloudId,
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
	}),
});
